import { render, staticRenderFns } from "./VoteDashboard.vue?vue&type=template&id=0f1d3045&scoped=true"
import script from "./VoteDashboard.vue?vue&type=script&lang=js"
export * from "./VoteDashboard.vue?vue&type=script&lang=js"
import style0 from "./VoteDashboard.vue?vue&type=style&index=0&id=0f1d3045&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d3045",
  null
  
)

export default component.exports